export enum QueryActivity {
    ACTIVITY = 'activity',
    USER = 'user',
    IDS = 'ids'
}